import { __decorate } from "tslib";
import { LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { ScopedElementsMixin } from '@open-wc/scoped-elements';
import { Skhemata } from '@skhemata/skhemata-api-client-js';
import { Bulma } from '@skhemata/skhemata-css';
export class SkhemataBase extends ScopedElementsMixin(LitElement) {
    constructor() {
        super(...arguments);
        /**
         * Skhemata API URL
         */
        this.api = {
            url: '',
        };
        /**
         * Translations directory
         */
        this.translationDir = '';
        /**
         * Language code (ISO)
         */
        this.translationLang = 'eng';
        /**
         * path to Configuration File
         */
        this.configSrc = '';
    }
    /* TODO: add validation and form error handling
    validateFormInputs(){
    }
  
    displayAPIFormErrors(){
    } */
    attributeChangedCallback(name, oldVal, newVal) {
        if (name === 'translation-lang') {
            this.translationSelected = this.translationData[this.translationLang];
        }
        super.attributeChangedCallback(name, oldVal, newVal);
    }
    /**
     * getStr
     * @param key key for translation
     * @returns translated string
     */
    getStr(key) {
        try {
            const value = key
                .split('.')
                .reduce((o, i) => o[i], this.translationSelected);
            return typeof value === 'string' ? value : key;
        }
        catch (_a) {
            return key;
        }
    }
    async firstUpdated() {
        var _a;
        // init API
        if ((_a = this.api) === null || _a === void 0 ? void 0 : _a.url) {
            this.skhemata = new Skhemata(this.api.url);
            this.skhemata.init();
        }
        if (this.configSrc) {
            this.configData = await fetch(this.configSrc).then(res => res.json());
        }
        // Load translations
        if (this.translationDir || this.translationData) {
            if (this.translationDir) {
                fetch(`${this.translationDir}${this.translationLang}.json`).then(res => {
                    this.translationSelected = res.json();
                });
            }
            else {
                this.translationSelected = this.translationData[this.translationLang];
            }
        }
        this.requestUpdate();
    }
}
SkhemataBase.styles = [Bulma];
__decorate([
    property({ type: Object, attribute: 'api' })
], SkhemataBase.prototype, "api", void 0);
__decorate([
    property({ type: String, attribute: 'translation-dir' })
], SkhemataBase.prototype, "translationDir", void 0);
__decorate([
    property({ type: Object, attribute: 'translation-data' })
], SkhemataBase.prototype, "translationData", void 0);
__decorate([
    property({ type: String, attribute: 'translation-lang' })
], SkhemataBase.prototype, "translationLang", void 0);
__decorate([
    property({ type: Object, attribute: false })
], SkhemataBase.prototype, "translationSelected", void 0);
__decorate([
    property({ type: Object, attribute: false })
], SkhemataBase.prototype, "skhemata", void 0);
__decorate([
    property({ type: String, attribute: 'config-src' })
], SkhemataBase.prototype, "configSrc", void 0);
__decorate([
    property({ type: Object, attribute: 'config-data' })
], SkhemataBase.prototype, "configData", void 0);
//# sourceMappingURL=SkhemataBase.js.map